import { type FC } from "react";

import {
	CalendarIcon,
	CheckCircleIcon,
	EmailIcon,
	EventScheduleIcon,
	HashtagIcon,
	LinkIcon,
	MoneyIcon,
	PercentageIcon,
	ProgressBarIcon,
	RowInsertIcon,
	StringTextIcon,
	TableIcon,
	TagIcon,
	ThumbsUpIcon,
	TimeIcon,
	UserAdminIcon,
} from "@moment/icons";

import { type ColumnType } from "../validation/parseColumnType";

/**
 * Icon representing the type of a column.
 */
export const ColumnTypeIcon: FC<{
	className?: string;
	size?: number;
	fieldType: ColumnType | undefined;
}> = ({ className, size = 16, fieldType }) => {
	const props = { size, className };
	switch (fieldType) {
		case "Text":
			return <StringTextIcon {...props} />;
		case "Tag":
			return <TagIcon {...props} />;
		case "Date":
			return <CalendarIcon {...props} />;
		case "Time":
			return <TimeIcon {...props} />;
		case "Date time":
			return <EventScheduleIcon {...props} />;
		case "Time distance to now":
			return <EventScheduleIcon {...props} />;
		case "Boolean":
			return <CheckCircleIcon {...props} />;
		case "Email":
			return <EmailIcon {...props} />;
		case "URL":
			return <LinkIcon {...props} />;
		case "Number":
			return <HashtagIcon {...props} />;
		case "Currency":
			return <MoneyIcon {...props} />;
		case "Percent":
			return <PercentageIcon {...props} />;
		case "Link to record":
			return <RowInsertIcon {...props} />;
		case "Reaction":
			return <ThumbsUpIcon {...props} />;
		case "Table":
			return <TableIcon {...props} />;
		case "Person":
			return <UserAdminIcon {...props} />;
		case "Progress bar":
			return <ProgressBarIcon {...props} />;
		default:
			return <StringTextIcon {...props} />;
	}
};
